import { IconProps, IconSize } from "../theme";

const DocumentCart: React.FC<IconProps> = ({ size = IconSize.XXL }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 80 80"
      fill="none"
    >
      <rect
        x="1"
        y="10"
        width="55"
        height="59"
        rx="6"
        fill="url(#paint0_linear_1901_18819)"
      />
      <rect x="7" y="47" width="45" height="16" rx="4" fill="white" />
      <rect x="11" y="52" width="34" height="1.5" rx="0.75" fill="#0F2162" />
      <rect x="11" y="57" width="23" height="1.5" rx="0.75" fill="#0F2162" />
      <rect x="34" y="2" width="32" height="32" rx="16" fill="white" />
      <path
        d="M47.4482 25.7692C47.4482 26.0127 47.3754 26.2506 47.239 26.453C47.1026 26.6554 46.9087 26.8132 46.6819 26.9063C46.455 26.9995 46.2054 27.0238 45.9646 26.9764C45.7238 26.9289 45.5027 26.8116 45.329 26.6395C45.1554 26.4674 45.0372 26.2481 44.9893 26.0093C44.9414 25.7706 44.966 25.5231 45.0599 25.2982C45.1539 25.0733 45.313 24.8811 45.5172 24.7459C45.7213 24.6106 45.9613 24.5385 46.2068 24.5385C46.536 24.5385 46.8518 24.6681 47.0846 24.8989C47.3174 25.1298 47.4482 25.4428 47.4482 25.7692ZM54.2757 24.5385C54.0302 24.5385 53.7902 24.6106 53.586 24.7459C53.3819 24.8811 53.2228 25.0733 53.1288 25.2982C53.0349 25.5231 53.0103 25.7706 53.0582 26.0093C53.1061 26.2481 53.2243 26.4674 53.3979 26.6395C53.5715 26.8116 53.7927 26.9289 54.0335 26.9764C54.2743 27.0238 54.5239 26.9995 54.7507 26.9063C54.9776 26.8132 55.1714 26.6554 55.3078 26.453C55.4442 26.2506 55.517 26.0127 55.517 25.7692C55.517 25.4428 55.3863 25.1298 55.1535 24.8989C54.9207 24.6681 54.6049 24.5385 54.2757 24.5385ZM57.8787 14.3269C57.821 14.2494 57.7457 14.1863 57.659 14.1429C57.5722 14.0995 57.4763 14.0769 57.3791 14.0769H43.7489L43.1197 11.8923C43.0446 11.6356 42.8877 11.41 42.6724 11.2492C42.4572 11.0883 42.1952 11.0009 41.9257 11H40.6207C40.4561 11 40.2982 11.0648 40.1818 11.1802C40.0654 11.2956 40 11.4522 40 11.6154C40 11.7786 40.0654 11.9351 40.1818 12.0505C40.2982 12.1659 40.4561 12.2308 40.6207 12.2308H41.9257L44.7327 21.9685C44.845 22.3535 45.0801 22.692 45.4028 22.9335C45.7255 23.1749 46.1184 23.3062 46.5226 23.3077H53.9793C54.3778 23.3091 54.7662 23.183 55.0868 22.9483C55.4074 22.7136 55.6432 22.3827 55.7591 22.0046L57.9726 14.8731C58.0011 14.7811 58.0075 14.6838 57.9912 14.5889C57.9749 14.4941 57.9364 14.4043 57.8787 14.3269Z"
        fill="#071443"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1901_18819"
          x1="46"
          y1="124"
          x2="-25.1035"
          y2="99.4202"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A1A0FE" />
          <stop offset="0.515625" stopColor="#E8B2ED" />
          <stop offset="1" stopColor="#FEE5DA" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default DocumentCart;
